import React, { useContext, useEffect, useState } from "react"
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { Container } from "react-bootstrap";
import FormStatusMolde from "./components/FormStatusMolde";
import TableStatusMolde from "./components/TableStatusMolde";
import blogFetch from "../../axios/config";

import Context from "../../context/Context";
import { LoadSpinner } from "../../componentes/atoms/LoadSpinner";

export default function StatusMolde() {

  return (
    <>
      <Navbar />
      <Sidebar />
      <Container fluid className="app_body">

        <TableStatusMolde
        />

      </Container>
    </>
  );
};

